import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LicenseState {  
  license: any;
  licenseConfig: any;
  hardLimit:any;
}

const initialState: LicenseState = {
  license: null,
  licenseConfig: null,
  hardLimit:null,
};

const licenseSlice = createSlice({
  name: 'license',
  initialState,
  reducers: {
    updateLicenseState: (state, action: PayloadAction<{ license: any; licenseConfig: any; hardLimit:any }>) => {
      state.license = action.payload.license;
      state.licenseConfig = action.payload.licenseConfig;
      state.hardLimit = action.payload.hardLimit;
    },
  },
});

export const { updateLicenseState } = licenseSlice.actions;
export default licenseSlice.reducer;
